import { z } from 'zod';

export const MenuCountersResponseSchema = z.object({
  // null for non-admins (Orders is an admin-only area) and whenever the market is disabled.
  pendingOrders: z.number().int().nonnegative().nullable(),
  pendingIdeas: z.number().int().nonnegative(),
});
export type MenuCountersResponse = z.infer<typeof MenuCountersResponseSchema>;
